import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "156",
  height: "156",
  viewBox: "0 0 156 156",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"156px","min-height":"156px"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill", "stroke"]
const _hoisted_4 = ["fill", "stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["fill", "stroke"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]
const _hoisted_10 = ["fill", "stroke"]
const _hoisted_11 = ["fill", "stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = ["stroke"]
const _hoisted_16 = ["stroke"]
const _hoisted_17 = ["stroke"]
const _hoisted_18 = ["stroke"]
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["fill", "stroke"]
const _hoisted_22 = ["stroke"]
const _hoisted_23 = ["fill", "stroke"]
const _hoisted_24 = ["fill", "stroke"]
const _hoisted_25 = ["stroke"]
const _hoisted_26 = ["stroke"]
const _hoisted_27 = ["stroke"]
const _hoisted_28 = ["stroke"]
const _hoisted_29 = ["stroke"]
const _hoisted_30 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CarLarge',
  props: {
    stroke: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0 8C0 3.58172 3.58172 0 8 0H148C152.418 0 156 3.58172 156 8V148C156 152.418 152.418 156 148 156H8C3.58172 156 0 152.418 0 148V8Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M71.3145 118.932C70.7876 118.932 70.2607 118.823 69.752 118.621L64.2471 116.296C61.8671 115.234 60.3955 111.957 60.3955 107.709C60.3955 103.938 61.5401 100.038 63.4477 97.2003L64.7195 81.4184L126.454 67.8701L126.981 82.9563L124.492 87.1672C123.965 92.7147 121.295 97.6946 117.988 99.1226C117.352 99.3973 116.753 99.5254 116.153 99.5254C115.626 99.5254 115.099 99.4156 114.591 99.2142L109.086 96.889C108.214 96.5045 107.451 95.7905 106.833 94.8202L79.6899 106.574C79.1631 112.122 76.4924 117.102 73.1858 118.53C72.5499 118.804 71.9504 118.932 71.3508 118.932H71.3145Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M121.458 85.611C121.458 82.0225 119.75 79.8438 117.624 80.7592C115.499 81.6747 113.791 85.3363 113.791 88.9248C113.791 92.5133 115.499 94.692 117.624 93.7765C119.732 92.8611 121.458 89.1994 121.458 85.611Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M114.917 83.8535L120.332 90.7009",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M120.332 81.4917L114.917 93.0626",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M76.6374 105.018C76.6374 101.43 74.9296 99.251 72.8039 100.166C70.6783 101.082 68.9705 104.744 68.9705 108.332C68.9705 111.92 70.6783 114.099 72.8039 113.184C74.9296 112.268 76.6374 108.607 76.6374 105.018Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M70.0969 103.242L75.511 110.108",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M75.511 100.898L70.0969 112.451",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M39.4472 63.9152C38.2844 61.3521 38.8113 58.3861 40.4827 57.1777C41.8453 57.5805 47.3866 60.0705 47.3866 60.0705L47.6591 65.1236L39.429 63.9152H39.4472Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M56.3433 114.868C43.2442 112.286 30.1995 105.823 23.1685 100.898C20.7521 99.2141 19.8438 98.0606 19.8438 95.8636V84.5307C19.8438 80.5578 22.0057 78.1227 24.6946 75.6145C27.3835 73.1062 37.9755 66.0575 37.9755 66.0575L49.0034 50.1657C50.8747 47.4561 51.5106 46.4491 54.4175 44.9478C58.0329 43.0804 62.2479 41.4692 65.5363 40.2059C70.1329 38.4483 75.3834 37.24 80.2343 38.7596C83.2138 39.6933 88.5371 41.5058 88.5371 41.5058L91.3531 41.0664C93.3334 40.6087 96.4947 41.4875 98.9292 41.9452C105.124 43.117 124.019 50.0193 131.177 55.9512C133.103 57.5623 134.775 59.4298 134.23 61.9015L134.175 62.1578V71.8429L135.156 74.0033V78.4889C135.156 79.7156 134.593 80.8873 133.63 81.6563L126.399 87.4051V85.4644C126.399 78.1594 122.911 73.747 118.605 75.5962C114.299 77.4453 110.811 84.8969 110.811 92.2019V95.2045L81.7786 107.764V104.762C81.7786 97.4565 78.2903 93.0441 73.9845 94.8933C69.6786 96.7607 66.1904 104.194 66.1904 111.499V114.502L65.5 114.795C62.575 116.058 60.4311 115.655 56.3251 114.831L56.3433 114.868Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M49.8575 48.6826C54.1815 52.4542 76.946 64.2448 90.9535 65.9841L93.3336 67.0277L109.085 60.1803L114.59 61.2605L116.807 63.8786L109.63 72.9962L83.9407 84.1461C83.9407 84.1461 80.8521 84.0545 75.7833 83.2856C65.5183 81.7477 38.2663 71.2752 37.9756 66.0207",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M134.139 61.938L129.324 64.0618L129.27 69.8106L134.139 67.5404",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M93.3341 67.0464L83.9412 84.1648V102.052",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M98.9111 64.8311L101.745 76.9696V94.6189",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M81.7793 103.004L110.812 90.4443",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M126.236 82.7002L135.138 76.75",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M116.807 76.8596V70.2503L113.282 68.3828",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M133.431 57.8922C133.431 57.8922 131.269 58.5147 128.289 59.2836C120.768 53.846 99.602 45.3692 88.5195 41.5244",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M112.047 50.825C107.777 52.2348 100.256 55.036 94.4967 57.8372C92.371 58.8624 89.9546 59.0455 87.7018 58.3315C77.0735 54.9627 67.4081 50.2941 62.0122 47.4197C61.34 47.0535 61.34 46.0831 62.0122 45.717C67.0811 42.8792 73.8578 40.261 79.2718 38.6499",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M51.5471 100.77L48.7129 100.496C48.7129 100.496 49.6031 97.7495 51.4563 97.9692C58.3965 98.8114 66.8628 96.2848 67.6803 95.4976C66.4086 96.9073 64.6826 101.173 64.3556 102.162C64.3556 102.162 62.4843 104.176 59.1232 104.176C56.2708 104.176 52.728 102.876 52.728 102.876L51.5471 100.77Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_21),
    _createElementVNode("path", {
      d: "M21.9155 78.5806C21.9155 78.5806 20.6074 80.2283 21.8428 82.5535C22.6967 84.1463 25.004 85.9955 26.8572 87.6066C28.5831 89.0896 28.4923 91.9823 28.4923 91.9823L26.3666 90.2247L25.44 91.9823C25.44 91.9823 23.4234 91.0303 21.8791 89.4741C19.7716 87.3503 19.8443 85.0984 19.8443 85.0984",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_22),
    _createElementVNode("path", {
      d: "M28.4922 91.9644C31.5444 95.1866 41.5187 100.02 48.7132 100.496C47.8048 102.18 46.5331 103.517 44.8434 103.279C39.0297 102.51 31.8351 98.7751 30.5452 96.7795C30.1637 96.1753 28.8919 94.8571 28.4922 91.9644Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_23),
    _createElementVNode("path", {
      d: "M88.1378 79.1661V82.425C91.1355 83.8165 97.7487 82.9926 98.4754 82.718C98.4754 79.99 98.3664 78.2141 97.0038 77.7198C95.6412 77.2254 91.0265 76.0171 91.0265 76.0171C89.3006 77.0241 88.1196 78.269 88.1196 79.1478L88.1378 79.1661Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_24),
    _createElementVNode("path", {
      d: "M66.2088 109.961L65.5184 110.254C62.5934 111.517 60.4495 111.115 56.3436 110.291C43.2444 107.709 30.1998 101.246 23.1687 96.3214C20.7524 94.6371 19.844 93.4836 19.844 91.2866",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_25),
    _createElementVNode("path", {
      d: "M77.2188 80.8691L83.4686 67.3208",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_26),
    _createElementVNode("path", {
      d: "M73.2761 80.1186L80.4162 66.4238",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_27),
    _createElementVNode("path", {
      d: "M75.7835 83.3041C66.9175 87.9911 63.7744 90.9754 60.3951 94.0512C45.788 93.1724 32.7434 87.2038 24.7131 80.5396",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_28),
    _createElementVNode("path", {
      d: "M23.9141 85.0437L24.6953 80.5581C26.8028 76.6768 31.8717 72.7587 38.8845 68.0718",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_29),
    _createElementVNode("path", {
      d: "M60.3956 94.0698L58.1973 97.64",
      stroke: __props.stroke,
      "stroke-width": "1.6",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_30)
  ]))
}
}

})